import { Outlet } from "react-router-dom";
import { Header } from "@/components/landing/header";

/**
 * Layout used ONLY by the chat page.
 * Header is rendered for navigation/identity, but the footer is intentionally
 * omitted so the chat UI can occupy the full viewport.
 */
export const ChatLayout = () => {
  return (
    <div className="min-h-svh flex flex-col bg-white">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  );
};
